import { useEffect } from 'react';
import { useBeforeUnload, useBlocker, useNavigate } from 'react-router-dom';

export default function usePrompt(
  when,
  message = 'Changes you made may not be saved.'
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (event) => {
      if (when) {
        event.preventDefault();
        event.returnValue = ''; // For compatibility with older browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when]);

  useBeforeUnload(
    (event) => {
      if (when) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
    { when }
  );

  const STRATEGY_WORKFLOW_PATTERN = /^\/(?:create|edit)Strategy/;

  const blocker = useBlocker(
    ({ currentLocation, nextLocation, historyAction }) => {
      // Don't block replace navigations that stay within the strategy creation/edit workflow
      // (e.g. updating the URL from /createStrategy to /createStrategy/123 after saving)
      const isInternalWorkflowReplace =
        historyAction === 'REPLACE' &&
        STRATEGY_WORKFLOW_PATTERN.test(currentLocation.pathname) &&
        STRATEGY_WORKFLOW_PATTERN.test(nextLocation.pathname);
      return (
        when &&
        !isInternalWorkflowReplace &&
        currentLocation.pathname !== nextLocation.pathname
      );
    }
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const confirmNavigation = window.confirm(message);
      if (confirmNavigation) {
        blocker.proceed();

        navigate(blocker.location.pathname, { replace: true });
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message, navigate]);

  return null;
}
